import { createAction, props } from '@ngrx/store';

const IDENTITY = '[Identity]';

export const fetchIdentityAction = createAction(`${IDENTITY} FetchIdentity`);

export const fetchIdentitySucceededAction = createAction(
  `${IDENTITY} FetchIdentitySucceeded`,
  props<{ account: any }>()
);

export const fetchIdentityFailedAction = createAction(
  `${IDENTITY} FetchIdentityFailed`,
  props<{ error }>()
);
